var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.495361,
    y: 11.8862,
    width: 28.4125,
    height: 17.7578,
    rx: 3.55157,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72946,
    y: 7.62473,
    width: 9.94438,
    height: 14.9166,
    rx: 2.13094,
    stroke: "white",
    strokeWidth: 2.84125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6086 21.4756H16.2683V22.8074C16.2683 23.6099 15.7356 24.1392 14.928 24.1392C14.1203 24.1392 13.5876 23.6099 13.5876 22.8074V21.4756H12.2473C11.4397 21.4756 10.907 20.9463 10.907 20.1438C10.907 19.3413 11.4397 18.812 12.2473 18.812H13.5876V17.4802C13.5876 16.6777 14.1203 16.1484 14.928 16.1484C15.7356 16.1484 16.2683 16.6777 16.2683 17.4802V18.812H17.6086C18.4162 18.812 18.9489 19.3413 18.9489 20.1438C18.9489 20.9292 18.4162 21.4756 17.6086 21.4756Z",
    fill: "#D8C6DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResearch);
export default __webpack_public_path__ + "static/media/icon-research.f31325a1967ca0f33c89b66887e9805c.svg";
export { ForwardRef as ReactComponent };